module.exports = __webpack_public_path__ + "img/1588180380.58b6861f.jpg";